<template>
  <div class="b-page">
    <div class="b-page__content">
      <h1 class="main-page">Документы</h1>
      <div class="container block-margin-bottom">
        <div class="mini_banners">
          <div class="container block-margin">
            <h2>Государственная пошлина за внесение сведений в ЕАИСТО</h2>
            <div class="row docs">
              <div class="item col col-md-4">
                <div class="image">
                  <a href="/files/реквизиты_пошлина_ЕАИСТО_ЮАО_23_12_2025.pdf"></a>
                  <a href="/files/реквизиты_пошлина_ЕАИСТО_ЮАО_23_12_2025.pdf"></a>
                  <img src="/files/dog.PNG" alt="Государственная пошлина за внесение сведений в ЕАИСТО" title="Государственная пошлина за внесение сведений в ЕАИСТО">

                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/реквизиты_пошлина_ЕАИСТО_ЮАО_23_12_2025.pdf">Государственная пошлина за внесение сведений в ЕАИСТО</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/реквизиты_пошлина_ЕАИСТО_ЮАО_23_12_2025.pdf" style="margin-left: 10px;">Скачать: PDF</a>
                  </div>
                </div>

              </div>
            </div>
            <h2>Типовой договор о проведении ТО</h2>
            <div class="row docs">
              <div class="item col col-md-4">
                <div class="image">
                  <a href="/files/карточка%20организации%20ТЕХУСПЕХ.pdf"></a>
                  <a href="/files/типовой%20договор%20о%20проведении%20ТО.doc"></a>
                  <img src="/files/dog.PNG" alt="Типовой договор о проведении ТО" title="Типовой договор о проведении ТО">

                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/типовой%20договор%20о%20проведении%20ТО.doc">Типовой договор о проведении ТО</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/типовой%20договор%20о%20проведении%20ТО.doc">Скачать: DOC</a>
                  </div>
                </div>

              </div>
            </div>
            <h2>Документация для пользователей</h2>
            <div class="row docs">
              <div class="item col col-md-4">
                <div class="image">
                  <a href="/files/Организации%20ООО%20ЮКОН.pdf"></a>
                  <img src="/files/cartochka.png" alt="ИНФОРМАЦИОННАЯ КАРТОЧКА" title="ИНФОРМАЦИОННАЯ КАРТОЧКА">

                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/Организации%20ООО%20ЮКОН.pdf">ИНФОРМАЦИОННАЯ КАРТОЧКА</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/Организации%20ООО%20ЮКОН.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
            </div>
            <h2>
              Учредительные документы
            </h2>
            <div class="row docs" >
              <div class="item col col-md-4">
                <div class="image">
                  <a href="/files/Приказ%20№1.pdf"></a>
                  <img src="/files/prikaz.png" alt="ПРИКАЗ №1"
                       title="ПРИКАЗ №1">
                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/Приказ%20№1.pdf">ПРИКАЗ
                        №1</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/Приказ%20№1.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
              <div class="item col col-md-4" >
                <div class="image">
                  <a href="/files/УСТАВ%20ЮКОН.pdf"></a>
                  <img src="/files/ustav.png" alt="УСТАВ" title="УСТАВ">
                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/УСТАВ%20ЮКОН.pdf">УСТАВ</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/УСТАВ%20ЮКОН.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
              <div class="item col col-md-4" >
                <div class="image">
                  <a href="/files/Уведомлени%20о%20переходе%20на%20упрощенную%20систему%20налогооблажения.pdf"></a>
                  <img src="/files/uvedomlenie.png" alt="УВЕДОМЛЕНИЕ"
                       title="УВЕДОМЛЕНИЕ">
                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/Уведомлени%20о%20переходе%20на%20упрощенную%20систему%20налогооблажения.pdf">УВЕДОМЛЕНИЕ</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/Уведомлени%20о%20переходе%20на%20упрощенную%20систему%20налогооблажения.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
              <div class="item col col-md-4" >
                <div class="image">
                  <a href="/files/СВИДЕТЕЛЬСТВО%20ФНС%20О%20ПОСТАНОВКЕ%20НА%20УЧЕТ%20В%20НАЛОГОВОЙ%20ЮКОН.pdf"></a>
                  <img src="/files/svidetelstvo.png" alt="ПОСТАНОВКА В НАЛОГОВОЙ"
                       title="ПОСТАНОВКА В НАЛОГОВОЙ">

                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/СВИДЕТЕЛЬСТВО%20ФНС%20О%20ПОСТАНОВКЕ%20НА%20УЧЕТ%20В%20НАЛОГОВОЙ%20ЮКОН.pdf">ПОСТАНОВКА
                        В НАЛОГОВОЙ</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/СВИДЕТЕЛЬСТВО%20ФНС%20О%20ПОСТАНОВКЕ%20НА%20УЧЕТ%20В%20НАЛОГОВОЙ%20ЮКОН.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
              <div class="item col col-md-4" >
                <div class="image">
                  <a href="/files/лист%20записи%20единого%20государственного%20реестра%20юр.лиц.pdf"></a>
                  <img src="/files/egryl.png" alt="ЕГРЮЛ" title="ЕГРЮЛ">

                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/лист%20записи%20единого%20государственного%20реестра%20юр.лиц.pdf">ЕГРЮЛ</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/лист%20записи%20единого%20государственного%20реестра%20юр.лиц.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
            </div>

            <h2>Лицензии и сертификаты</h2>
            <div class="row docs">
              <div class="item col col-md-4">
                <div class="image">
                  <a href="/files/АТТЕСТАТ.pdf"></a>
                  <img src="/files/atestat.png" alt="АТТЕСТАТ" title="АТТЕСТАТ">

                </div>
                <div class="data">
                  <div class="info smaller">
                    <div class="name">
                      <a class="aprimary" href="/files/АТТЕСТАТ.pdf">АТТЕСТАТ</a>
                    </div>
                  </div>
                  <div class="dl">
                    <a href="/files/АТТЕСТАТ.pdf">Скачать: PDF</a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Docs"
}
</script>

<style scoped>

</style>